import { ProjectDTO } from '../dto/project-dto';
import { LFProject } from '../models/lfproject';

export class LFProjectFactory {
  static fromDTO(projectDTO: ProjectDTO): LFProject {
    const item = new LFProject();
    item.id = projectDTO.id;
    item.text = projectDTO.text;
    item.shortDescription = projectDTO.shortDescription;
    item.group = projectDTO.group;
    item.location = projectDTO.location;
    item.rights.createOrders = projectDTO.rights.createOrders;
    item.rights.releaseOrders = projectDTO.rights.releaseOrders;
    item.rights.cancelOrders = projectDTO.rights.cancelOrders;
    item.rights.processRight = projectDTO.rights.processRight;
    return item;
  }
}
